import { render, staticRenderFns } from "./AdminLocationsAndRegions.vue?vue&type=template&id=46d344ca"
import script from "./AdminLocationsAndRegions.vue?vue&type=script&lang=js"
export * from "./AdminLocationsAndRegions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports